<script setup lang="ts">
import { PV } from "@/components";
import { useRouter } from "vue-router";

const router = useRouter();

async function onBack() {
    if (router.options.history.state.back !== undefined) {
        router.back();
    }
}
</script>

<template>
    <div class="flex flex-col w-full h-screen items-center justify-center gap-8">
        <i class="pi pi-exclamation-triangle" style="font-size: 8rem"></i>
        <div class="font-bold text-4xl">Halaman yang anda tuju tidak ditemukan.</div>
        <PV.Button label="Kembali" severity="secondary" size="large" @click="onBack" />
    </div>
</template>
